// EmailDetails.tsx
import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardBody, Col, Row } from 'reactstrap';
import BadgeComponent from './RenderBadge';

// Define the props for the EmailDetails component
interface EmailDetailsProps {
  email: {
    [key: string]: any;
    title: String;
    id: number;
    message: string;
    date: string;
    category: string;
    priority: string;
  } | null;
  handleBackClick: () => void;
}

// EmailDetails component definition
const NotificationDetails: React.FC<EmailDetailsProps> = ({ email, handleBackClick }) => {
  // Check if email is null, display a message to select an email
  if (!email) return <div>Select an email to view details</div>;

  return (
    <React.Fragment>
      <Row>
        <Col xs="12">
          <Card>
            <CardBody>
              <h4 className="font-size-16">{email.title}</h4>
              <div className='m-1'>
                <BadgeComponent title="Category" className='m-1' text={email.category} badgeColors={email.category_color_light} />
                <BadgeComponent title="Priority" className='m-1' text={email.priority} badgeColors={email.priority_color_light} /> |
                <span title="Date"> {new Date(email.date).toLocaleString()}</span>
              </div>
              <hr />
              <p>{email.message}</p>
              <hr />
              <Link
                to="#"
                className="btn btn-secondary waves-effect mt-4"
                onClick={handleBackClick}
              >
                <i className="mdi mdi-reply me-1"></i> Back
              </Link>
            </CardBody>
          </Card>

        </Col>
      </Row>

    </React.Fragment>
  );
};

export default NotificationDetails;